import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { isAdminActionRequired } from "../util/tradeUtils";

const useStyles = makeStyles((theme) => ({
  redStatusColor: {
    color: theme.palette.primary.swaRed,
  },
}));

const StatusCell = (props) => {
  const classes = useStyles();

  const renderStatus = (status, isAdminPage) => {
    if (isAdminPage) {
      if (isAdminActionRequired(status)) {
        return (
          <Tooltip title="ACTION REQUIRED" arrow placement="right">
            <p className={classes.redStatusColor}>{status}</p>
          </Tooltip>
        );
      }
    }
    return <p>{status}</p>;
  };

  return renderStatus(props.status, props.isAdminPage);
};

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
};

export default StatusCell;
